/**
 * Central mask definitions for ngx-mask.
 * Import MASKS to use consistent mask strings across all templates.
 *
 * Usage in template:
 *   <input [mask]="MASKS.PHONE" />
 *   <input [mask]="MASKS.CPF" [dropSpecialCharacters]="false" />
 */
export const MASKS = {
  /** Suporte fixo (10 dígitos) e celular (11 dígitos): (XX) XXXX-XXXX || (XX) XXXXX-XXXX */
  PHONE: '(00) 0000-0000||(00) 00000-0000',
  /** CPF: 000.000.000-00 */
  CPF: '000.000.000-00',
  /** CNPJ: 00.000.000/0000-00 */
  CNPJ: '00.000.000/0000-00',
  /** CEP: 00000-000 */
  CEP: '00000-000',
  /** CNH (número do registro): 00000000000 */
  CNH: '00000000000',
  /** RENAVAM: 00000000000 */
  RENAVAM: '00000000000',
  /** Placa Mercosul e antiga: SSS0S00 || SSS-0000 */
  PLATE: 'SSS-0S00||SSS0S00',
} as const;
